<!-- 窜货防伪设置 -->
<template>
    <div class="container">
        <!-- 防窜货设置 -->
        <div class="content section-trace">
            <div class="section-header">
                <Icon type="ios-shield-outline" size="20" />
                <span>防窜货设置</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="150">
                <Row :gutter="24">
                    <Col span="20">
                        <FormItem label="启用防窜货预警：">
                            <i-switch v-model="formData.warn_status" size="large" true-color="var(--primary-color)" :true-value="1" :false-value="0">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                            <Tooltip max-width="280" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                <div slot="content">
                                    <p>配合经销商模块，智能分析匹配并预警。如购买了短信则会短信同步通知</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                </Row>
                <template v-if="formData.warn_status">
                    <Row :gutter="24">
                        <Col span="20">
                            <FormItem label="防窜货预警等级：">
                                <Select class="w200" v-model="formData.warn_level" clearable filterable placeholder="请选择等级">
                                    <Option v-for="item in warnLevelList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                                </Select>
                                <Tooltip max-width="280" placement="top" theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>宽松只验证省份，标准验证省+市级，严格验证省+市级+县市</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                    </Row>
                </template>
            </Form>
        </div>

        <!-- 防伪设置 -->
        <div class="content section-security">
            <div class="section-header">
                <Icon type="ios-finger-print-outline" size="20" />
                <span>防伪设置</span>
                <span class="section-tip">（启用后生效）</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="150">
                <Row :gutter="24">
                    <Col span="20">
                        <FormItem label="启用防伪预警：">
                            <i-switch v-model="formData.preview_status" size="large" true-color="var(--primary-color)" :true-value="1" :false-value="0">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                            <Tooltip max-width="280" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                <div slot="content">
                                    <p>启用后如果查询超过预警数则开始预警</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                </Row>
                <template v-if="formData.preview_status == 1">
                    <Row :gutter="24">
                        <Col span="20">
                            <FormItem label="防伪预警触发量：">
                                <Input class="w200" type="text" v-model="formData.warn_num" placeholder="请输入触发量"></Input>
                                <Tooltip max-width="280" placement="top" theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>防伪查询次数大于该数时自动触发防伪预警（默认10次）</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                    </Row>
                </template>
            </Form>
        </div>

        <!-- 提交按钮 -->
        <div class="footer">
            <Button class="theme-bc theme-default-color btn-submit" @click="submitForm">
                <Icon type="ios-checkmark-circle-outline" size="18" /> 确定保存
            </Button>
        </div>
    </div>
</template>

<script>
import { system_security_index, system_security_save } from '@/api/index';
export default {
    data() {
        return {
            formData: {
                warn_status: 1,
                warn_level: 2,
                warn_sms: 0,
                preview_status: 1,
                warn_num: 10,
                preview_sms: 0,
            },
            warnLevelList: [
                { id: 1, name: "宽松" },
                { id: 2, name: "标准" },
                { id: 3, name: "严格" },
            ],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList(){
            system_security_index().then((res) => {
                if(res.data && res.data.length != 0){
                    this.formData.warn_status = res.data.warn_status;
                    this.formData.warn_level = res.data.warn_level;
                    this.formData.warn_sms = res.data.warn_sms;
                    this.formData.preview_status = res.data.preview_status;
                    this.formData.warn_num = res.data.warn_num;
                    this.formData.preview_sms = res.data.preview_sms;
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        submitForm(){
            system_security_save(this.formData).then( res => {
                this.getList();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.content {
    padding: 20px 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
/* 区块标题 */
.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
    font-weight: 600;
    font-size: 16px;
    color: #333;
}
.section-header i {
    margin-right: 8px;
    color: #666;
}
.section-tip {
    margin-left: 8px;
    font-weight: normal;
    font-size: 13px;
    color: #999;
}
/* 防窜货区块 */
.section-trace {
    border-left: 4px solid #f59e0b;
}
.section-trace .section-header i {
    color: #f59e0b;
}
/* 防伪区块 */
.section-security {
    border-left: 4px solid #10b981;
}
.section-security .section-header i {
    color: #10b981;
}
/* 页脚 */
.footer {
    padding: 20px 0;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.btn-submit {
    padding: 5px 40px;
    font-size: 15px;
}
.btn-submit i {
    margin-right: 6px;
}
/* 通用样式 */
.cursor-p {
    cursor: pointer;
}
.ml8 {
    margin-left: 8px;
}
.w200 {
    width: 200px;
}
</style>
